import { debounce } from '@mui/material/utils';
import {
  GridToolbarContainer,
  gridQuickFilterValuesSelector,
  useGridApiContext,
  useGridSelector,
} from '@mui/x-data-grid';
import SearchField from 'components/controls/SearchField';
import PropTypes from 'prop-types';
import * as React from 'react';
import { useEffect, useState } from 'react';

const defaultSearchValueParser = searchText =>
  searchText.match(/(?:\S+:"[^"]*"|\S+:\S+|\S+)/g) || [];

const GridToolbarSearch = ({ debounceMs = 500, children = null, ...other }) => {
  const apiRef = useGridApiContext();
  const quickFilterValues = useGridSelector(apiRef, gridQuickFilterValuesSelector) ?? [];

  const gridSearchValue = quickFilterValues.join(' ');
  const [value, setValue] = useState(gridSearchValue);

  useEffect(() => {
    setValue(gridSearchValue);
  }, [gridSearchValue]);

  const updateSearchValue = React.useCallback(
    newSearchValue => {
      apiRef.current.setQuickFilterValues(defaultSearchValueParser(newSearchValue));
    },
    [apiRef],
  );

  const debouncedUpdateSearchValue = React.useMemo(
    () => debounce(updateSearchValue, debounceMs),
    [updateSearchValue, debounceMs],
  );

  const handleSearchValueChange = React.useCallback(
    event => {
      const newSearchValue = event.target.value;
      debouncedUpdateSearchValue(newSearchValue);
      setValue(newSearchValue);
    },
    [debouncedUpdateSearchValue],
  );

  return (
    <GridToolbarContainer sx={{ mt: 3 }}>
      <SearchField value={value} onChange={handleSearchValueChange} {...other} />
      {children}
    </GridToolbarContainer>
  );
};

GridToolbarSearch.propTypes = {
  /**
   * The debounce time in milliseconds.
   * @default 500
   */
  debounceMs: PropTypes.number,
  children: PropTypes.node,
};

export default GridToolbarSearch;
